/*
 * @Descripttion: 城市缓存（sessionStorage，仅在当前会话内复用，退出页面后重新定位）
 * @version: 3.0.0.0
 */
const CITY_CACHE_KEY = 'geo_city_v1'
const CITY_CACHE_TTL = 12 * 60 * 60 * 1000

export const readCityCache = () => {
  try {
    const raw = sessionStorage.getItem(CITY_CACHE_KEY)
    if (!raw) return ''
    const { city, ts } = JSON.parse(raw)
    if (!city || !ts || Date.now() - ts > CITY_CACHE_TTL) {
      sessionStorage.removeItem(CITY_CACHE_KEY)
      return ''
    }
    return city
  } catch (e) {
    return ''
  }
}

export const writeCityCache = (city) => {
  if (!city) return
  try {
    sessionStorage.setItem(CITY_CACHE_KEY, JSON.stringify({ city, ts: Date.now() }))
  } catch (e) {
    // 隐私模式或存储配额满，忽略即可
  }
}

export const clearCityCache = () => {
  try {
    sessionStorage.removeItem(CITY_CACHE_KEY)
  } catch (e) {
    // ignore
  }
}
